// Gammes de panneaux et d'onduleurs imposées par le contexte du projet (VIRYA_SUNL-16055).
//
// Le matériel NZIA est exigé :
//  - en AC, quand le mécanisme de revente est AOS/AOCRE ;
//  - en VT, quand la puissance totale dépasse SEUIL_PCREBAT (à égalité, pas de NZIA).
// Le raccordement choisit ensuite l'onduleur : String en BT, 800V en HTA.

export const PANNEAU_CRE = 'CRE'
export const PANNEAU_NZIA = 'NZIA'
export const ONDULEUR_STRING = 'STRING'
export const ONDULEUR_STRING_NZIA = 'STRING_NZIA'
export const ONDULEUR_800V = 'ONDULEUR_800V'
export const ONDULEUR_800V_NZIA = 'ONDULEUR_800V_NZIA'

/** Onduleurs String : seuls à porter le coffret DC et le paratonnerre côté formulaire. */
export const ONDULEURS_STRING = [ONDULEUR_STRING, ONDULEUR_STRING_NZIA]

export interface ContexteGammeMateriel {
  modeValorisation: string | null
  /** true en BT, false en HTA. */
  raccordementBt: boolean
  mecanismeReventeSurplus: string | null
  /** Puissance totale calculée dans le bloc raccordement, null tant qu'elle ne l'est pas. */
  puissanceTotaleKwc: number | null
  seuilPcreBat: number | null
}

export interface GammeMateriel {
  /** Panneaux proposés, null pour tous. */
  panneauxAutorises: string[] | null
  /** Onduleurs proposés, null pour tous. */
  onduleursAutorises: string[] | null
  /** Onduleurs retirés de la liste quand tous les autres restent proposés. */
  onduleursExclus: string[]
  panneauParDefaut: string
  onduleurParDefaut: string
}

export function isMaterielNziaExige(contexte: ContexteGammeMateriel): boolean {
  if (contexte.modeValorisation === 'AC') {
    return contexte.mecanismeReventeSurplus === 'AOS_AOCRE'
  }
  if (contexte.modeValorisation === 'VT') {
    return contexte.puissanceTotaleKwc != null
      && contexte.seuilPcreBat != null
      && contexte.puissanceTotaleKwc > contexte.seuilPcreBat
  }
  return false
}

export function determinerGammeMateriel(contexte: ContexteGammeMateriel): GammeMateriel {
  const nzia = isMaterielNziaExige(contexte)
  if (nzia && contexte.raccordementBt) {
    return {
      panneauxAutorises: [PANNEAU_NZIA],
      onduleursAutorises: [ONDULEUR_STRING_NZIA],
      onduleursExclus: [],
      panneauParDefaut: PANNEAU_NZIA,
      onduleurParDefaut: ONDULEUR_STRING_NZIA,
    }
  }
  if (nzia) {
    return {
      panneauxAutorises: [PANNEAU_NZIA],
      onduleursAutorises: [ONDULEUR_800V_NZIA, ONDULEUR_STRING_NZIA],
      onduleursExclus: [],
      panneauParDefaut: PANNEAU_NZIA,
      onduleurParDefaut: ONDULEUR_800V_NZIA,
    }
  }
  if (contexte.raccordementBt) {
    return {
      panneauxAutorises: null,
      onduleursAutorises: null,
      onduleursExclus: [ONDULEUR_800V, ONDULEUR_800V_NZIA],
      panneauParDefaut: PANNEAU_CRE,
      onduleurParDefaut: ONDULEUR_STRING,
    }
  }
  return {
    panneauxAutorises: null,
    onduleursAutorises: null,
    onduleursExclus: [],
    panneauParDefaut: PANNEAU_CRE,
    onduleurParDefaut: ONDULEUR_800V,
  }
}

export function filtrerCodes<T extends { code: string }>(options: T[], autorises: string[] | null, exclus: string[] = []): T[] {
  return options.filter((option) =>
    (autorises === null || autorises.includes(option.code)) && !exclus.includes(option.code))
}
